<template>
  <div>
    <v-toolbar dark flat color="grey-lighten">
      <v-toolbar-title>Gestión de personas</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>

      <v-spacer></v-spacer>

      <v-dialog v-model="dialog" persistent max-width="700px">
        <v-btn slot="activator" color="primary" dark class="mb-2">Nuevo</v-btn>

        <v-card>
          <v-card-title class="headline info">
            <span>{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.numeroDocumento" label="Número documento"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.primer_nombre" label="Primer nombre"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.segundo_nombre" label="Segundo nombre"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.primer_apellido" label="Primer apellido"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.segundo_apellido" label="Segundo apellido"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="editedItem.email" label="Correo electrónico"></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <h3>Bloques</h3>
                  <v-select
                    v-model="editedItem.bloques"
                    :items="bloques"
                    label="Bloques"
                    item-text="nombre"
                    return-object
                    multiple
                    chips
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" @click="close">Cancelar</v-btn>
            <v-btn color="green darken-1" @click="save">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-toolbar>

      <v-dialog v-model="dialog8" persistent max-width="50%">
        <v-card>
          <v-card-text>
            <div>
              <h4 class="headline mb-0">GESTIÓN DE TRASLADOS</h4>
            </div>

            <div v-if="tableDataTraslados.length">
              <div v-if="tableDataTraslados[0].bloques.length">
                <v-data-table
                  :headers="headersBloques"
                  :items="tableDataTraslados[0].bloques"
                  class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td>
                      <a
                        href="#"
                        @click="obtenerResultadoTraslado(tableDataTraslados[0].id, props.item.id)"
                      >{{ props.item.nombre}}</a>
                    </td>
                  </template>
                </v-data-table>
              </div>
              <v-alert v-else color="lime darken-3" style="display:block">
                <label>No tiene bloques relacionados</label>
              </v-alert>
            </div>
            <v-alert v-else color="lime darken-3" style="display:block">
              <label>No tiene relación en traslados</label>
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" @click="dialog8 = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogEliminar" persistent max-width="290">
        <v-card>
          <v-card-title class="headline info">Eliminar registro</v-card-title>

          <v-card-text>¿Está seguro de eliminar el registro?</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="red darken-1" @click="dialogEliminar = false">Cancelar</v-btn>

            <v-btn color="green darken-1" @click="confirmDeleteItem">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogErrorEliminar" persistent max-width="50%">
        <v-card>
          <v-card-title class="headline info">Eliminar registro</v-card-title>

          <v-card-text>No se puede eliminar este registro porque tiene información relacionada con bloques y/o representantes.</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue darken-1" @click="dialogErrorEliminar = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="mostrar_resultados" persistent>
        <v-card>
          <v-card-title class="headline text-uppercase">
            FORMULARIO DILIGENCIADO POR
            {{tableData[0] === undefined ? 'LA VICTIMA' : tableData[0].nombre }}
            {{tableData[0] === undefined ? '' : obtenerBloqueTraslado(tableData[0].bloques, parametros.bloque_id)[0] === undefined ? '' : ` - ${obtenerBloqueTraslado(tableData[0].bloques, parametros.bloque_id)[0].nombre}` }}
          </v-card-title>
          <v-card-text>
            <Respuestas></Respuestas>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success darken-1" text @click="descargarPdf()">Descargar PDF</v-btn>
            <v-btn color="red darken-1" text @click="mostrar_resultados = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar..."
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table :headers="headers" :items="tableData" :search="search" class="elevation-1">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.numeroDocumento }}</td>
        <td>{{ props.item.name }}</td>
        <td class="text-xs">{{ props.item.email }}</td>
        <td class="text-xs text-center">
          <div v-for="representante in props.item.representantes" :key="representante.id">
            <v-chip class="ma-2" text-color="white" color="blue accent-4">{{ representante.name }}</v-chip>
          </div>
        </td>
        <td class="text-xs text-center">
          <div v-for="bloque in props.item.bloques" :key="bloque.id">
            <v-chip
              class="ma-2"
              @click="obtenerResultadoTraslado(props.item.id, bloque.id)"
              :color="bloque.tieneRelacionTraslado === 1 ? 'green accent-4' : 'red accent-4'"
              text-color="white"
            >{{ bloque.nombre }}</v-chip>
          </div>
        </td>
        <td>
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>

      <template slot="no-data">
        <v-btn color="primary" @click="initialize">Recargar</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { EventBus } from "../../../EventBus";
import Traslado from "../../../services/Traslado";

export default {
  data: () => ({
    dialog: false,
    dialog8: false,
    dialogEliminar: false,
    dialogErrorEliminar: false,
    mostrar_resultados: false,
    search: "",
    headers: [
      { text: "Número documento", value: "numeroDocumento" },
      { text: "Nombre completo", value: "name" },
      { text: "Correo electrónico", value: "email" },
      {
        text: "Representante",
        value: "representantes",
        align: "center",
        sortable: false,
      },
      { text: "Bloques", value: "bloques", align: "center", sortable: false },
      { text: "Acciones", value: "name", sortable: false },
    ],
    headersBloques: [{ text: "Nombre Bloque", value: "nombre" }],
    parametros: {},
    tableDataTraslados: [],
    tableData: [],
    editedIndex: -1,
    bloques: [],
    editedItem: {
      numeroDocumento: "",
      name: "",
      primer_nombre: "",
      segundo_nombre: "",
      primer_apellido: "",
      segundo_apellido: "",
      email: "",
      created_at: "",
      bloques: [],
    },
    defaultItem: {
      numeroDocumento: "",
      name: "",
      primer_nombre: "",
      segundo_nombre: "",
      primer_apellido: "",
      segundo_apellido: "",
      email: "",
      created_at: "",
      bloques: [],
    },
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Formulario de creación"
        : "Formulario de edición";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      const requestPersonas = axios.get("/api/personas");
      const requestBloques = axios.get("/api/traslados/bloques");

      axios
        .all([requestPersonas, requestBloques])
        .then(
          axios.spread((...responses) => {
            this.tableData = responses[0].data.data;
            this.bloques = responses[1].data.data;
          })
        )
        .catch((errors) => {
          console.log(errors);
        });
    },
    obtenerNombreCompleto(persona) {
      let nombreCompleto = persona.primer_nombre;
      nombreCompleto = persona.segundo_nombre
        ? `${nombreCompleto} ${persona.segundo_nombre}`
        : nombreCompleto;
      nombreCompleto = `${nombreCompleto} ${persona.primer_apellido}`;
      nombreCompleto = persona.segundo_apellido
        ? `${nombreCompleto} ${persona.segundo_apellido}`
        : nombreCompleto;
      return nombreCompleto;
    },
    obtenerResultadoTraslado(persona, bloque) {
      this.mostrar_resultados = true;
      this.parametros = {
        persona_id: persona,
        bloque_id: bloque,
        tipo_usuario: "despacho",
        usuario_id: this.$auth.user.user.id,
      };
      EventBus.$emit("parametros", this.parametros);
    },
    obtenerBloqueTraslado(bloques, bloque_id) {
      return bloques.filter((x) => x.id === bloque_id);
    },
    gestionTraslados(item) {
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.tableDataTraslados = [];
      let documento = this.editedItem.numeroDocumento;
      axios
        .get(`/api/traslados/personas/${documento}/victima`)
        .then((response) => {
          this.tableDataTraslados = response.data.data;
        });
      this.dialog8 = true;
    },
    descargarPdf() {
      let persona_id = this.parametros.persona_id;
      let bloque_id = this.parametros.bloque_id;

      this.show_export_spinner = true;

      let ruta = `/api/traslados/personas/${persona_id}/bloque/${bloque_id}/respuestas/pdf`;
      Traslado.getObtenerPDFResultadoTrasladoXBloque(persona_id, bloque_id)
        .then((response) => {
          this.show_export_spinner = false;

          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "formulario_traslado.pdf");

          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log("Ha ocurrido un error en la exportación a PDF");
          this.show_export_spinner = false;
        });
    },
    editItem(item) {
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.tableData.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogEliminar = true;
    },
    confirmDeleteItem() {
      axios
        .delete("/api/personas/" + this.editedItem.id)
        .then((response) => {
          this.tableData.splice(this.editedIndex, 1);
        })
        .catch((error) => {
          this.dialogErrorEliminar = true;
        });
      this.dialogEliminar = false;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      this.editedItem.name = this.obtenerNombreCompleto(this.editedItem);
      if (this.editedIndex > -1) {
        axios
          .put("/api/personas/" + this.editedItem.id, this.editedItem)
          .then((response) => {
            Object.assign(this.tableData[this.editedIndex], response.data.data);
            this.close();
          });
      } else {
        axios.post("/api/personas/", this.editedItem).then((response) => {
          this.tableData.push({
            ...response.data.data,
          });
          this.close();
        });
      }
    },
  },
};
</script>
